import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LogoLockup } from "@/components/Logo";

export const PublicHeader = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0A0A0A]/90 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
          <LogoLockup />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
          <Link to="/#features" className="hover:text-white transition-colors">Features</Link>
          <Link to="/#models" className="hover:text-white transition-colors">Models</Link>
          <Link to="/pricing" className="hover:text-white transition-colors" data-testid="nav-pricing">Pricing</Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Button
              data-testid="header-open-app"
              onClick={() => navigate("/app")}
              className="bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg h-9 px-4 transition-colors"
            >
              Open App
            </Button>
          ) : (
            <>
              <button
                data-testid="header-login"
                onClick={() => navigate("/login")}
                className="text-sm text-zinc-300 hover:text-white transition-colors"
              >
                Sign in
              </button>
              <Button
                data-testid="header-get-started"
                onClick={() => navigate("/login")}
                className="bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg h-9 px-4 transition-colors"
              >
                Get started free
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export const PublicFooter = () => (
  <footer className="border-t border-white/10 bg-[#0A0A0A]">
    <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
      <div className="col-span-2 md:col-span-1">
        <div className="flex items-center gap-2 mb-3">
          <LogoLockup mark="w-7 h-7" text="text-lg" />
        </div>
        <p className="text-sm text-zinc-500 leading-relaxed">
          The free all-in-one AI coding assistant. Build anything.
        </p>
      </div>
      <div>
        <h3 className="text-white font-semibold text-sm mb-3">Product</h3>
        <ul className="space-y-2 text-sm text-zinc-500">
          <li><Link to="/#features" className="hover:text-white transition-colors">Features</Link></li>
          <li><Link to="/#models" className="hover:text-white transition-colors">Models</Link></li>
          <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="text-white font-semibold text-sm mb-3">Get started</h3>
        <ul className="space-y-2 text-sm text-zinc-500">
          <li><Link to="/login" className="hover:text-white transition-colors">Sign up</Link></li>
          <li><Link to="/login" className="hover:text-white transition-colors">Sign in</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="text-white font-semibold text-sm mb-3">Company</h3>
        <ul className="space-y-2 text-sm text-zinc-500">
          <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact">Contact us</Link></li>
          <li><a href="mailto:ai@nigamai.com" className="hover:text-white transition-colors">ai@nigamai.com</a></li>
        </ul>
      </div>
      <div>
        <h3 className="text-white font-semibold text-sm mb-3">Legal</h3>
        <ul className="space-y-2 text-sm text-zinc-500">
          <li><Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms & Conditions</Link></li>
          <li><Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
          <li><Link to="/refund" className="hover:text-white transition-colors" data-testid="footer-refund">Refund & Cancellation</Link></li>
          <li><Link to="/shipping" className="hover:text-white transition-colors" data-testid="footer-shipping">Shipping & Delivery</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-zinc-600">
      © {new Date().getFullYear()} NIGAMAI by Liza Tech Solution. All rights reserved.
    </div>
  </footer>
);
